class DeliveryDates {
    // eslint-disable-next-line class-methods-use-this
    selectDeliveryDates(component, deliveryDates, oldData) {
        const options = [];

        Object.entries(deliveryDates).forEach(([key, value]) => {
            let isDefault = false;

            if (key === 'ASAP') {
                // eslint-disable-next-line no-param-reassign,no-underscore-dangle
                key = component.__('redeem.asap_delivery');
                isDefault = true;
            }

            options.push({
                id: value,
                text: key,
                default: isDefault,
                isOldValue: false,
            });
        });

        if (
            oldData !== []
            && oldData !== {}
            && oldData.delivery_date !== undefined
            && oldData.delivery_date !== ''
        ) {
            const option = options.find((opt) => opt.id === oldData.delivery_date);

            if (option) {
                option.isOldValue = true;
            } else {
                const today = new Date();
                const oldDate = new Date(oldData.delivery_date);
                if (oldDate > today) {
                    options.push({
                        id: oldData.delivery_date,
                        text: oldData.delivery_date,
                        isOldValue: true,
                    });
                }
            }
        }

        options.sort((a, b) => {
            if (b.default) {
                return true;
            }

            return new Date(a.id) - new Date(b.id);
        });

        return options;
    }
}

export default (new DeliveryDates());
